import { Button } from "@oxygen/core";
import { DetectLocation } from "@oxygen/icons";
import getThemeClasses from "@oxygen/theme";
import { CSSFlex } from "GlobalComponent/CSSCore";
import OxygenLoader from "GlobalComponent/OxygenLoader";
import { platform as PLATFORM } from "GlobalEnum/Platform";
import { isNotNullOrEmptyArray } from "GlobalUtils/Common";
import React, { useCallback } from "react";
import { PopularCities } from "./PopularCities";
import styles from "./scss/LocationPopup.module.scss";

const confirmButtonClasses = getThemeClasses(`
  mt-8 md:mt-0;
  ml-auto md:ml-0;
  mr-auto md:mr-0;
`);
const detectMyLocationContainerClasses = getThemeClasses(`
  mt-6;
  mb-6;
  ml-auto;
  mr-auto;
  pl-4 md:pl-0;
  align-items-flex-start;
  flex-direction-column;
  width-full;
  justify-content-space-between;
  ${styles.detectMyLocationContainer}
`);

const detectMyLocationClasses = getThemeClasses(`
  align-items-center;
  cursor-pointer;
  color-blue-light;
  ${styles.detectMyLocation}
`);
const detectMyLocationTextClasses = getThemeClasses(`
  ml-2;
  font-size-8;
`);

function LocationPopupBody({
  handleCitySelection,
  onSelection,
  onConfirmClick,
  isConfirmButtonVisible,
  autoDetect,
  onAutoDetectClick,
  confirmButtonDisabled,
  confirmButtonColor,
  confirmButtonVariant,
  platform,
  popularCities,
  children,
}) {
  const handleConfirmClick = useCallback(() => {
    onConfirmClick && onConfirmClick();
    onSelection && onSelection();
  }, [onConfirmClick, onSelection]);
  return (
    <>
      <CSSFlex className={detectMyLocationContainerClasses}>
        {autoDetect && (
          <CSSFlex
            className={detectMyLocationClasses}
            onClick={onAutoDetectClick}
          >
            <DetectLocation size="md" />
            <div
              className={detectMyLocationTextClasses}
              data-testing-id="detect-my-location"
            >
              Detect my location
            </div>
          </CSSFlex>
        )}
        {isConfirmButtonVisible && (
          <Button
            onClick={handleConfirmClick}
            disabled={confirmButtonDisabled}
            color={confirmButtonColor}
            variant={confirmButtonVariant}
            size={platform.id === PLATFORM.DESKTOP.id ? "sm" : "md"}
            className={confirmButtonClasses}
          >
            Confirm
          </Button>
        )}
      </CSSFlex>
      {children}
      {!isNotNullOrEmptyArray(popularCities) ? (
        <OxygenLoader />
      ) : (
        <PopularCities
          cities={popularCities}
          onCityClick={handleCitySelection}
        />
      )}
    </>
  );
}

export default LocationPopupBody;
